import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import { Navbar, Nav }  from "react-bootstrap";



class Menu extends Component {

  constructor() {
    
    super()
    if (localStorage.getItem('sessionId') === null) {
      window.location.reload(false);
    }
    
    this.state = {
      isNavExpanded: false,
      showNavbar: true,
      lastScrollY: 0,
      screenheight: 0
    };
    
    this.setIsNavExpanded = (isNavExpanded) => {
      this.setState({ isNavExpanded: isNavExpanded });
    };

    this.handleClick = (e) => {
        this.setState({ isNavExpanded: false });
    }

    this.handleScroll = this.handleScroll.bind(this);

  }


  handleScroll() {
        const { lastScrollY } = this.state;
        const currentScrollY = document.body.scrollTop;
        if (currentScrollY > lastScrollY && currentScrollY > 100) { // Adjust 100 to your desired scroll threshold
          // this.setState({ showNavbar: false });
	  this.setState({ showNavbar: true });
        } else {
          this.setState({ showNavbar: true });
        }
        this.setState({ lastScrollY: currentScrollY });

        //const screenHeight = screen.height;
      }


  componentDidMount() {
    document.addEventListener('click', this.handleClick, false);
    document.body.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
        document.body.removeEventListener('scroll', this.handleScroll);
      }

  render(){
    
    const { showNavbar } = this.state;      

    return (
<Navbar id="MenuTop" collapseOnSelect expand="lg" variant="light" 
className={showNavbar ? 'navbar-visible navbar fixed-top shadow' : 'navbar-hidden navbar fixed-top shadow'}

style={{ 
  backgroundColor: '#FFFFFF'
  }}
>


  <Link to="/"><img src={localStorage.getItem('logo')} alt="VERTIKAL TRIP" height="45"  style={{ marginTop: '9px', marginBottom: '9px', marginRight: '15px' }} /></Link>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" style={{ borderColor: "#c53c46" }}>
     <i className="fas fa-bars m-2" style={{ color: "#c53c46" }}></i>
  </Navbar.Toggle>
  <Navbar.Collapse id="responsive-navbar-nav">
    <Nav className="mr-auto">
      {JSON.parse(localStorage.getItem('categories')).map((category,index) => {
          return (
            <Nav.Link as={Link} style={{ color: "#000000" }} className="menu-hover nav-link font-weight-bold ml-2" to={{ pathname: "/tours/"+ category.slug }}  eventKey="0" key={index}><i className="fas fa-atlas fa-lg fa-fw"></i><span className="ml-1">{category.name}</span></Nav.Link>
            )     
        })}
    </Nav>
    <Nav className="navbar-nav text-uppercase ml-auto mb-1">

            <Nav.Link as={Link}  style={{ color: "#c53c46" }} className="nav-link font-weight-bold display-on-desktop ml-2 mt-2" to={{ pathname: "/booking/checkout" }} eventKey="0"><span className="display-on-desktop"><i className="fas fa-shopping-cart fa-lg fa-fw mr-2"></i>Cart</span></Nav.Link>
            <Nav.Link as={Link}  style={{ color: "#c53c46" }} className="nav-link font-weight-bold display-on-desktop ml-2 mt-2" to={{ pathname: "/booking/lastorder" }} eventKey="0"><span className="display-on-desktop"><i className="fas fa-file-signature fa-lg fa-fw mr-2"></i>My Order</span></Nav.Link>
            
            
    </Nav>
  </Navbar.Collapse>

</Navbar>




            )
  }
}

export default Menu;
